// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewList_root___6O6z","wrap":"ReviewList_wrap__8_ZU8","list":"ReviewList_list__QY3Xb"};